"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrazilianStateByName = exports.getBrazilianStateByInitials = exports.getBrazilianStates = void 0;
const brazilian_states_json_1 = __importDefault(require("../../jsons/brazilian_states.json"));
/**
 * @description Uma função que retorna um array com todos os estados brasileiros.
 * @returns Um array de estados brasileiros no formato `IBrazilianState`.
 */
function getBrazilianStates() {
  return brazilian_states_json_1.default.UF;
}
exports.getBrazilianStates = getBrazilianStates;
/**
 * @description Busca um estado brasileiro pela sua inicial.
 * @param initials Iniciais do estado que será buscado.
 * @returns Um objeto do tipo `IBrazilianState` ou `null`.
 */
function getBrazilianStateByInitials(initials) {
  if (initials) {
    return brazilian_states_json_1.default.UF.find(state => state.initials.toUpperCase() === initials.toUpperCase()) || null;
  }
  return null;
}
exports.getBrazilianStateByInitials = getBrazilianStateByInitials;
/**
 * @description Busca um estado brasileiro pelo nome.
 * @param name Nome do estado que será buscado.
 * @returns Um objeto do tipo `IBrazilianState` ou `null`.
 */
function getBrazilianStateByName(name) {
  if (name) {
    const regex = new RegExp(name, "i");
    const filteredStates = brazilian_states_json_1.default.UF.filter(item => regex.test(item.name));
    return filteredStates[0] || null;
  }
  return null;
}
exports.getBrazilianStateByName = getBrazilianStateByName;